import { patientList } from './consts'
import { PatientRequestCard } from './patientRequestCard'

export const RollingPatientCards = () => {
  return (
    <div
      className='relative flex max-h-[608px] flex-col overflow-hidden'
      style={{
        maskImage:
          'linear-gradient(to bottom, transparent 0%, white 15%, white 85%, transparent 100%)',
      }}
    >
      <div className='flex animate-[verticalRollUp_64s_linear_infinite] flex-col gap-4 pt-4'>
        {patientList.map((patient) => (
          <PatientRequestCard key={`${patient.name}-0`} {...patient} />
        ))}
      </div>
      <div className='flex animate-[verticalRollUp_64s_linear_infinite] flex-col gap-4 pt-4'>
        {patientList.map((patient) => (
          <PatientRequestCard key={`${patient.name}-1`} {...patient} />
        ))}
      </div>
    </div>
  )
}
